export const UTM_GROUP = {
  LIMIT_HITTERS: 'UEVrM6c5BkW62UHs6hVq4Q',
  EASTER_PROMO: 'yKkJNEN9V77mADZU5k59gw',
} as const;

const isGroupUtmValue = (
  param: string | null
): param is (typeof UTM_GROUP)[keyof typeof UTM_GROUP] => {
  return Object.values(UTM_GROUP).includes(
    param as (typeof UTM_GROUP)[keyof typeof UTM_GROUP]
  );
};

const isAuthType = (param: string | undefined): param is 'google' | 'local' => {
  return param === 'google' || param === 'local';
};

export function useUTMSearchParams() {
  const searchParams =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams();

  const authType = searchParams.get('auth_type')?.toLowerCase();
  const authCode = searchParams.get('auth_code') ?? undefined;
  const prefillCode = searchParams.get('prefill_code') ?? undefined;
  const group = searchParams.get('group');

  return {
    authCode,
    authType: isAuthType(authType) ? authType : undefined,
    prefillCode,
    group: isGroupUtmValue(group) ? group : undefined,
  };
}
